export default __webpack_public_path__ + "static/media/banners_posthotsale_coche_330x330.61da78c0.jpg";